import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import Footer from '../Footer';
import IconButton from '../IconButton';
import ErrorIcon from '../Icons/ErrorScreen';
import CloseIcon from '../Icons/Times';

const ErrorScreen = () => {
  const {
    fontFamily,
    header: {
      height: headerHeight,
      background: headerBackground,
      title: { color: headerColor }
    },
    window: { colors, borderRadius, boxShadow }
  } = useConfig();
  const { t } = useTranslation();
  const { chatWindow } = useStores();

  return (
    <Root
      textFontFamily={fontFamily}
      backgroundColor={colors.background}
      borderRadius={borderRadius}
      boxShadow={boxShadow}
    >
      <Header headerHeight={headerHeight} backgroundColor={headerBackground}>
        <IconButton
          className="react-rnd-draggable-cancel"
          onClick={() => {
            chatWindow.close();
          }}
        >
          <CloseIcon fill={headerColor} />
        </IconButton>
      </Header>
      <Wrap>
        <Image />
        <Content>
          <Text textColor={colors.accent}>{t('oops')}</Text>
          <Descr textColor={colors.main}>{t('errorScreenNotification')}</Descr>
          <Descr textColor={colors.main}>{t('refreshPage')}</Descr>
        </Content>
      </Wrap>
      <Footer />
    </Root>
  );
};

const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  font-family: ${({ textFontFamily }) => textFontFamily};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  box-shadow: ${props => props.boxShadow};
  overflow: hidden;

  footer {
    box-shadow: none;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: ${({ headerHeight }) => `${headerHeight}px`};
  padding: 2px 20px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  button {
    cursor: pointer;
    :hover {
      opacity: 0.5;
    }
  }
`;

const Wrap = styled.div`
  flex: 1 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Image = styled(ErrorIcon)`
  width: 163px;
  height: 130px;
  margin-bottom: 20px;
`;

const Content = styled.div`
  p {
    margin: 0 0 10px;
  }
`;

const Text = styled.p`
  margin: 0 0 10px;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  text-align: center;
  color: ${({ textColor }) => textColor};
`;

const Descr = styled.p`
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: center;
  color: ${({ textColor }) => textColor};
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export default observer(ErrorScreen);
